module.exports = __webpack_public_path__ + "static/media/art57.4ef2625f.jpg";